

import {httpservice} from '../services';
import {constants} from '../constant/constant';

export default isEnabled => {
    return httpservice()
        .post(isEnabled ? constants.API.ENABLE_SMS : constants.API.DISABLE_SMS)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error.response.data;
        });
};